// src/store.js
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        messages: [],
        sessionId: ''
    },
    mutations: {
        setMessages(state, messages) {
            state.messages = messages;
        },
        addMessage(state, message) {
            state.messages.push(message);
        },
        updateMessage(state, { index, content }) {
            state.messages[index].content = content;
        },
        resetMessages(state) {
            state.messages = [];
        },
        setSessionId(state, sessionId) {
            state.sessionId = sessionId;
        }
    },
    actions: {},
    modules: {}
});
